module.exports = __webpack_public_path__ + "static/pic-4@3x-65d82221ec58fe57592cf14993dfd0aa.png";